module.exports = __webpack_public_path__ + "static/feaster-a52a04cba8047cf222ef512196e07112.png";